import { render, staticRenderFns } from "./adVance.vue?vue&type=template&id=480bf94e&scoped=true"
import script from "./adVance.vue?vue&type=script&lang=js"
export * from "./adVance.vue?vue&type=script&lang=js"
import style0 from "./adVance.vue?vue&type=style&index=0&id=480bf94e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480bf94e",
  null
  
)

export default component.exports